import { createApi } from '@reduxjs/toolkit/query/react'
import { createBffApiBaseQuery } from './apiClients'

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: createBffApiBaseQuery('authApi', { baseUrl: process.env.REACT_APP_BACKEND_BASE_URL }),
    endpoints: (builder) => ({
        getAuthMe: builder.query({
            query: () => ({
                url: '/api/auth/me',
                method: 'GET',
                credentials: 'include'
            }),
            extraOptions: { refreshCsrfAfterResponse: true }
        }),
        twitchSignIn: builder.query({
            query: (redirectUri) => `/oauth2/authorization/twitch?redirect_uri=${redirectUri}`,
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
        }),
        twitchCodeAuth: builder.query({
            query: (args) => {
                const { code, state } = args;
                return {
                    url: `/login/oauth2/code/twitch`,
                    params: { code, state },
                    credentials: 'include'
                }
            },
            transformResponse: (response, meta) => {
                const redirectUri = meta.response.headers.get('Location');
                return { redirectUri };
            },
            extraOptions: { refreshCsrfAfterResponse: true },
        }),
        logout: builder.mutation({
            query: () => ({
                url: '/api/auth/logout',
                method: 'POST'
            }),
            extraOptions: { refreshCsrfAfterResponse: true },
        })
    }),
})

export const {
    useGetAuthMeQuery,
    useLazyGetAuthMeQuery,
    useLazyTwitchSignInQuery,
    useLazyTwitchCodeAuthQuery,
    useLogoutMutation
} = authApi
